import { render, staticRenderFns } from "./KpisEnderecosOrigemPainel.vue?vue&type=template&id=8ee548d6&"
import script from "./KpisEnderecosOrigemPainel.vue?vue&type=script&lang=js&"
export * from "./KpisEnderecosOrigemPainel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports